import { ButtonType } from '../../../../controls/button/button.component';

export interface CalculatorColorConfig {
  bgColor: string;
  borderColor: string;
  secondaryButtonType: ButtonType;
  primaryButtonType: ButtonType;
  textColor: string;
  borderClass: string;
  afterBorderTopClass: string; // Used for little arrows in range sliders
  accentClass: string; // Slider in rage class
  primaryColor?: string;
  secondaryColor?: string;
}

export const defaultCalculatorColorConfig: CalculatorColorConfig = {
  bgColor: 'bg-sun-yellow',
  borderColor: 'border-sun-yellow',
  secondaryButtonType: 'secondary-blue',
  primaryButtonType: 'primary-blue-2',
  textColor: 'text-blue1',
  borderClass: '!border-sun-yellow',
  afterBorderTopClass: 'after:border-t-sun-yellow',
  accentClass: 'accent-blue1',
};
